require('./bootstrap');
require('./livewire_events');
require('./mail_events');

window.Swal = require('sweetalert2');


